export * from './app-settings';


// WEBPACK FOOTER //
// ./src/app/infrastructure/settings/index.ts